
import './App.css';
import AppRouter from './Router';

function App() {
  return (
    <AppRouter></AppRouter>
  );
}

export default App;
